import { EventEmitter, Injectable } from '@angular/core';
import { Ride } from '../interfaces/ride-data/ride-list.interface';

@Injectable({
  providedIn: 'root',
})
export class RideNavigationService {
  public onChangeData: EventEmitter<Ride> = new EventEmitter();

  constructor() {}
}
